import Vue from 'vue'
import Vuex from 'vuex'

import LocaleModule from './modules/LocaleModule'
import RouteModule from './modules/RouteModule'
import WorldMapModule from './modules/WorldMapModule'
import LocalStorageModule from './modules/LocalStorageModule'
import PageModule from './modules/page/PageModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
  	LocaleModule,
  	route: RouteModule,
  	WorldMapModule,
  	PageModule,
  	// EconomicIndicatorModule,
  	// InternationalRatingsModule,
  	localStorage: LocalStorageModule
  }
})
